export function neverError(token: never, message?: string): Error {
  return new Error(`${token} should not exist. ${message ?? ''}`);
}
